import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DateTimeSelectorService } from '../../modules/shared/date-time-selector/date-time-selector.service';

export interface ReportZone {
    timezone: string;
    // display text only, compare zones by timezone
    name: string;
}

/**
 * Fed by ReportTimezoneInterceptor, so it must not depend on anything that sends requests itself
 * (e.g. UserService) - that would make a circular dependency through the interceptor chain.
 */
@Injectable({
    providedIn: 'root'
})
export class ReportTimezoneService {

    private readonly reportZone = new BehaviorSubject<ReportZone | null>(null);
    private timeRangeVersion = 0;

    constructor() {
        inject(DateTimeSelectorService).dateTimeOptionQueryParams.subscribe(() => this.startNewTimeRangeVersion());
    }

    public currentTimeRangeVersion(): number {
        return this.timeRangeVersion;
    }

    public record(zone: ReportZone, timeRangeVersion: number): void {
        if (timeRangeVersion === this.timeRangeVersion) {
            this.reportZone.next(zone);
        }
    }

    public get reportZone$(): Observable<ReportZone | null> {
        return this.reportZone.asObservable();
    }

    private startNewTimeRangeVersion(): void {
        this.timeRangeVersion++;
        this.reportZone.next(null);
    }
}
